"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaFornecedor = exports.yupFornecedor = void 0;
const yup = __importStar(require("yup"));
const estado_1 = require("./estado");
exports.yupFornecedor = yup.object({
    nome: yup.string().default('').max(40, 'Máximo de 40 caracteres').required().label('Nome'),
    fantasia: yup.string().default('').max(40, 'Máximo de 40 caracteres').notRequired().label('Nome Fantasia'),
    contato: yup.string().default('').max(40, 'Máximo de 40 caracteres').notRequired().label('Contato'),
    endereco: yup.string().default('').max(40, 'Máximo de 40 caracteres').notRequired().label('Endereco'),
    cep: yup.string().default('').max(10, 'Máximo de 10 caracteres').notRequired().label('Cep'),
    cidade: yup.string().default('').max(75, 'Máximo de 75 caracteres.').label('Cidade'),
    uf: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .default('')
        .label('Estado'),
    fone: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Telefone Residencial'),
    cgc: yup.string().default('').max(18, 'Máximo de 18 caracteres').notRequired().label('Cgc'),
    inscricao: yup.string().default('').max(18, 'Máximo de 18 caracteres').notRequired().label('Inscricao'),
    provisao: yup.string().default('').max(9, 'Máximo de 9 caracteres').notRequired().label('Provisao'),
    despesa: yup.string().default('').max(9, 'Máximo de 9 caracteres').notRequired().label('Despesa'),
    grupo: yup.number().default(0).label('Grupo'),
    tipoPessoa: yup.string().default('').max(1, 'Máximo de 1 caracteres').notRequired().label('Tipo Pessoa'),
    inativo: yup.boolean().required().default(false).label('Inativo'),
    idPlanoDespesa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Plano Conta - Despesa'),
    idPlanoProvisao: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Plano Conta - Provisao'),
});
exports.schemaFornecedor = exports.yupFornecedor.shape({});
